export const NO_RESULTS = "No survey results";
export const NO_COACH_SELECTED = "No coach selected";
export const NO_COACH_SELECTED_AD = "No AD selected";


// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/utils/getHeaderText/constants.ts